module.exports = __webpack_public_path__ + "img/jy-img.9422d595.png";